export const TourSidebarFilterLabel = ({ label }) => {
  return <div className="mb-1 text-sm font-semibold">{label}</div>;
};
